import { useState } from 'react';
import styles from './ui.module.css';

export default function SlidingButton({ children, onClick }) {
  const [isHovered, setIsHovered] = useState(false);
  
  return ( 
      <button
        className={styles.button}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
      >
        <span className={styles.backgroundBase}></span>
        
        <span 
          className={`${styles.backgroundSlide} ${
            isHovered ? styles.slideActive : ''
          }`}
        ></span>
        
        <span className={styles.content}>
        {children}
        </span>
      </button>
  );
}